import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Navbar from './components/Navbar/Navbar';
import Homepage from './components/Homepage/Homepage';
import { Routes,Route } from 'react-router-dom';
import ServicesPage from './components/ServicesPage/ServicesPage';
import SolarServices from './components/ServicesPage/SolarServices';
import StreetLightServices from './components/ServicesPage/StreetLightServices';
import Footer from './components/Footer/Footer';
import TubeWellPumpServices from './components/ServicesPage/TubeWellPumpServices';
import FlowMeter from './components/ServicesPage/FlowMeter';
import ApplicationSoftwareDevelopment from './components/ServicesPage/ApplicationSoftwareDevelopment';
import PlcHmiScada from './components/ServicesPage/PlcHmiScada';
import AboutUs from './components/AboutUs/AboutUs';
import ContactUs from './components/ContactUs/ContactUs';
import Career from './components/Career/Career';
import 'aos/dist/aos.css';
import AboutOurTeam from './components/AboutUs/AboutOurTeam';
import AboutOurCertifications from './components/AboutUs/AboutOurCertifications';
import RightSideMenu from './components/RightSideMenu/RightSideMenu';
import Gallery from './components/Gallery/Gallery';
import OurNewsLetter from './components/AboutUs/OurNewsLetter';
import Projects from './components/Projects/Projects';
// import Wishes from './components/wishes/Wishes';





function App() {
  return (
    <div className="App">

      <Navbar/>
      {/* <Wishes/> */}
      {/* <RightSideMenu/> */}
      <Routes>
      <Route path="/" element={<Homepage/>}></Route>
      <Route path="/services" element={<ServicesPage/>}></Route>
      <Route path='/solar-services' element={<SolarServices/>}></Route>
      <Route path='/street-light-automation-services' element={<StreetLightServices/>}></Route>
      <Route path='/tube-well-pump-automation-services' element={<TubeWellPumpServices/>}></Route>
      <Route path='/flow-meter-automation-services' element={<FlowMeter/>}></Route>
      <Route path='/application-software-services' element={<ApplicationSoftwareDevelopment/>}></Route>
      <Route path='/plc-hmi-drive-and-scada' element={<PlcHmiScada/>}></Route>
      <Route path='/about-us' element={<AboutUs/>}></Route>
      <Route path='/contact-us' element={<ContactUs/>}></Route>
      <Route path='/career' element={<Career/>}></Route>
      <Route path='/about-our-team' element={<AboutOurTeam/>}></Route>
      <Route path="/our-certifications" element={<AboutOurCertifications/>}></Route>
      <Route path='/gallery' element={<Gallery/>}></Route>
      <Route path='/our-newsletter' element={<OurNewsLetter/>}></Route>
      <Route path='/projects' element={<Projects/>}></Route>

      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
